import React, { useState } from "react"
import * as S from "./styled"
import { InputComponent } from "src/uikit/Input"
import { graphql, useStaticQuery } from "gatsby"
import { getNodesByLocale } from "src/common/getNodesByLocale"
import { useLocale } from "src/common/hooks"
import { createSubmit } from "src/common/hubspot"
import Button from "src/newUikit/Button"

const fields = ["firstname", "lastname", "phone", "company", "email"]

const labelsMap = {
  firstname: "name",
  lastname: "lastName",
  email: "companyEmail",
  company: "company",
  phone: "phone",
}

const Form = ({
  modalType,
  btnColor = "cyan",
  transparent = false,
  onSuccess,
  downloadAssetModalId,
}) => {
  const locale = useLocale()

  const [isLoading, setIsLoading] = useState(false)
  const [isDisabled, setIsDisabled] = useState(true)
  const [form, setForm] = useState({
    firstname: "",
    lastname: "",
    company: "",
    email: "",
    phone: "",
    errors: {},
  })

  const data = useStaticQuery(
    graphql`
      query {
        allContentfulModalsDownloadAsset {
          nodes {
            modalId
            node_locale
            title
            name
            lastName
            company
            companyEmail
            phone
            successTitle
            successCloseButton
            successBody {
              json
            }
            errorEmail
            errorPhoneField
            errorEmptyField
            submitButton
            formId
            portalId
            downloadAsset {
              asset {
                file {
                  url
                  fileName
                }
                node_locale
              }
            }
          }
        }
      }
    `
  )

  const node = getNodesByLocale(
    data.allContentfulModalsDownloadAsset.nodes,
    locale
  ).find(item => item.modalId === downloadAssetModalId)

  const { formId, portalId } = node

  const submit = createSubmit({
    formId,
    portalId,
  })

  const handleChangeInput = e => {
    const { id, value } = e.target
    setForm({
      ...form,
      [id]: value,
    })
    setIsDisabled(fields.every(field => (field === id ? !value : !form[field])))
  }

  const handleSubmit = async () => {
    const errors = {}

    fields.forEach(field => {
      const value = form[field]

      if (value.trim() === "") {
        errors[field] = node.errorEmptyField

        return
      }
    })

    if (Object.keys(errors).length > 0) {
      setForm({
        ...form,
        errors,
      })
      return
    }

    setIsLoading(true)

    try {
      const result = await submit(fields, form)

      if (result.status === 200) {
        onSuccess()
      }
    } catch (err) {
      const hubSpotErrors = {}

      err.response?.data.errors?.forEach(({ errorType }) => {
        if (errorType === "NUMBER_OUT_OF_RANGE") {
          hubSpotErrors.phone = node.errorPhoneField
        }

        if (errorType === "INVALID_EMAIL") {
          hubSpotErrors.email = node.errorEmail
        }
      })

      setForm(prevValue => ({ ...prevValue, errors: hubSpotErrors }))
    }

    setIsLoading(false)
  }

  const { errors } = form

  return (
    <S.Container
      transparent={transparent ? 1 : 0}
      modalType={modalType ? 1 : 0}
    >
      <S.FormContainer modalType={modalType ? 1 : 0}>
        {fields.map(field => (
          <InputComponent
            key={field}
            isValid={errors[field] === undefined}
            type={field === "email" ? "email" : "text"}
            label={node[labelsMap[field]]}
            id={field}
            error={errors[field]}
            value={form[field]}
            onChange={handleChangeInput}
          />
        ))}
      </S.FormContainer>
      <Button
        color={btnColor}
        disabled={isDisabled || isLoading}
        onClick={handleSubmit}
      >
        {node.submitButton}
      </Button>
    </S.Container>
  )
}

export default Form
